import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { Previous, Next } from 'Constant';

const PaginationComponent = ({ pagination, handleBackPagination, handleClickPagination, handleNextPagination, maxPagesToShow = 5 }) => {
    const startPage = Math.max(pagination.currentPage - Math.floor(maxPagesToShow / 2), 1);
    const endPage = Math.min(startPage + maxPagesToShow - 1, pagination.lastPage);

    return (
        <Pagination className="pagination justify-content-center pagination-primary" aria-label="Page navigation example">
            <PaginationItem disabled={pagination.currentPage === 1}>
                <PaginationLink onClick={() => handleBackPagination()}>{'Prev'}</PaginationLink>
            </PaginationItem>
            {startPage > 1 && (
                <PaginationItem>
                    <PaginationLink onClick={() => handleClickPagination(1)}>1</PaginationLink>
                </PaginationItem>
            )}
            {startPage > 2 && (
                <PaginationItem>
                    <PaginationLink disabled>...</PaginationLink>
                </PaginationItem>
            )}
            {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
                <PaginationItem key={startPage + i} active={pagination.currentPage === startPage + i}>
                    <PaginationLink onClick={() => handleClickPagination(startPage + i)}>{startPage + i}</PaginationLink>
                </PaginationItem>
            ))}
            {endPage < pagination.lastPage && (
                <PaginationItem>
                    <PaginationLink disabled>...</PaginationLink>
                </PaginationItem>
            )}
            {endPage < pagination.lastPage && (
                <PaginationItem>
                    <PaginationLink onClick={() => handleClickPagination(pagination.lastPage)}>{pagination.lastPage}</PaginationLink>
                </PaginationItem>
            )}
            <PaginationItem disabled={pagination.currentPage === pagination.lastPage}>
                <PaginationLink onClick={() => handleNextPagination()}>{Next}</PaginationLink>
            </PaginationItem>
        </Pagination>
    );
};

export default PaginationComponent;